<!-- @format -->

@if (studyEvents$ | async; as studyEvents) {
  @if (visibleStudyEvents$ | async; as visibleStudyEvents) {
    <span class="control-label form-control-static tiny-static-form-group ng-scope">
      {{ "ENROLMENTS.ENROLMENT_MODAL.STUDY_GROUP.GROUP_SIZE" | transloco }}
      @if (ssgSize) {
        <span class="value">{{ "ENROLMENTS.ENROLMENT_MODAL.STUDY_GROUP.NUMBER_OF_STUDENTS" | transloco: { number: ssgSize } }}</span>
      } @else {
        <span class="value">{{ "ENROLMENTS.ENROLMENT_MODAL.STUDY_GROUP.SIZE_NOT_DEFINED" | transloco }}</span>
      }
    </span>
    <div class="table-responsive top-spacing">
      @if (visibleStudyEvents$ | async; as visibleStudyEvents) {
        <table [attr.aria-label]="'ENROLMENTS.ENROLMENT_MODAL.STUDY_GROUP.EVENTS_ARIA_LABEL' | translate" class="table styled-table">
          <caption>
            {{ "ENROLMENTS.ENROLMENT_MODAL.STUDY_GROUP.TIME_AND_PLACE_INFO" | translate }}
          </caption>
          <thead>
            <tr>
              <th class="col-4">{{ "ENROLMENTS.ENROLMENT_MODAL.STUDY_GROUP.EVENTS_TIME" | translate }}</th>
              <th class="col-4">{{ "ENROLMENTS.ENROLMENT_MODAL.STUDY_GROUP.EVENTS_PLACE" | translate }}</th>
              <th class="col-4">{{ "ENROLMENTS.ENROLMENT_MODAL.STUDY_GROUP.EVENTS_TEACHER" | translate }}</th>
            </tr>
          </thead>
          <tbody>
            @if (studyEvents.length === 0) {
              <tr>
                <td>{{ "ENROLMENTS.ENROLMENT_MODAL.STUDY_GROUP.EVENTS_NO_TIME" | translate }}</td>
                <td>{{ "ENROLMENTS.ENROLMENT_MODAL.STUDY_GROUP.EVENTS_NO_LOCATION" | translate }}</td>
                <ng-container [ngTemplateOutlet]="teachers"></ng-container>
              </tr>
            }
            @if (studyEvents.length > 0) {
              @for (studyEvent of visibleStudyEvents; track studyEvent) {
                <tr>
                  <td>
                    <span class="day"
                      >{{ studyEvent | studyEventWeekdayOrInterval }} {{ studyEvent | studyEventDateRange }}
                      {{ studyEvent | studyEventTimeRange }}</span
                    >
                  </td>
                  <td>
                    @if (studyEvent.locationIds?.length === 0) {
                      <span>{{ "ENROLMENTS.ENROLMENT_MODAL.STUDY_GROUP.EVENTS_NO_LOCATION" | translate }}</span>
                    }
                    @if (studyEvent.locationIds?.length > 0) {
                      <div class="study-sub-group-container__body__table__row">
                        <ng-container
                          [ngTemplateOutlet]="personAndLocationList"
                          [ngTemplateOutletContext]="{ isPersonPipe: false, values: studyEvent.locationIds }"></ng-container>
                        <ng-container
                          [ngTemplateOutlet]="popover"
                          [ngTemplateOutletContext]="{
                            showPopover: hasIrregularLocations(studyEvent.events),
                            popoverText: 'ENROLMENTS.ENROLMENT_MODAL.STUDY_GROUP.EVENTS_LOCATION_CHANGES',
                          }">
                        </ng-container>
                      </div>
                    }
                  </td>
                  <ng-container [ngTemplateOutlet]="teachers"></ng-container>
                </tr>
              }
            }
          </tbody>
        </table>
      }
    </div>
    <ng-template
      [ngTemplateOutlet]="showMore"
      [ngTemplateOutletContext]="{ showMore: visibleStudyEvents.length !== studyEvents.length, studyEvents: studyEvents }"></ng-template>
  }
  @if (irregularEvents.length > 0) {
    <sis-expandable [variant]="'link'" [title]="'ENROLMENTS.ENROLMENT_MODAL.STUDY_GROUP.EVENTS_SHOW_EXCEPTIONS' | translate">
      <ng-template sisExpandableContent>
        @for (irregularEvent of irregularEvents; track irregularEvent) {
          <div class="study-sub-group-container__body__events">
            <div class="study-sub-group-container__body__events__header"
              >{{ irregularEvent.start | date: "EEEE" : null : getCurrentLanguage() }} {{ irregularEvent.start | date: "dd.MM.yyyy" }}
              {{
                irregularEvent.end ? getTime(irregularEvent.start) + "-" + getTime(irregularEvent.end) : getTime(irregularEvent.start)
              }}</div
            >
            @if (irregularEvent.cancelled) {
              <sis-tiny-badge variant="danger">{{ "ENROLMENTS.ENROLMENT_MODAL.STUDY_GROUP.EVENTS_CANCELLED" | translate }}</sis-tiny-badge>
            }
            @if (irregularEvent.excluded) {
              <sis-tiny-badge variant="danger">{{ "ENROLMENTS.ENROLMENT_MODAL.STUDY_GROUP.EVENTS_EXCLUDED" | translate }}</sis-tiny-badge>
            }
            @if (!irregularEvent.excluded && !irregularEvent.cancelled) {
              @if (irregularEvent.irregularLocationIds) {
                <div>
                  <span
                    >{{ "ENROLMENTS.ENROLMENT_MODAL.STUDY_GROUP.EVENTS_LOCATION_CHANGE" | translate }}
                    @if (irregularEvent.irregularLocationIds.length === 0) {
                      {{ "ENROLMENTS.ENROLMENT_MODAL.STUDY_GROUP.EVENTS_LOCATION_REMOVED" | translate }}
                    }
                    <ng-container
                      [ngTemplateOutlet]="personAndLocationList"
                      [ngTemplateOutletContext]="{ isPersonPipe: false, values: irregularEvent.irregularLocationIds }"></ng-container>
                  </span>
                </div>
              }
            }
            @if (irregularEvent.notice) {
              <div>
                <span
                  >{{ "ENROLMENTS.ENROLMENT_MODAL.STUDY_GROUP.EVENTS_ADDITIONAL_INFO" | translate }}
                  {{ irregularEvent.notice | localizedString }}</span
                >
              </div>
            }
          </div>
        }
      </ng-template>
    </sis-expandable>
  }
}

<ng-template #teachers>
  <td>
    @if (!teacherIds || teacherIds.length === 0) {
      <span>{{ "ENROLMENTS.ENROLMENT_MODAL.STUDY_GROUP.EVENTS_NO_TEACHER" | translate }}</span>
    }
    @if (teacherIds && teacherIds.length > 0) {
      <div class="study-sub-group-container__body__table__row">
        <ng-container
          [ngTemplateOutlet]="personAndLocationList"
          [ngTemplateOutletContext]="{ isPersonPipe: true, values: teacherIds }"></ng-container>
      </div>
    }
  </td>
</ng-template>

<ng-template #showMore let-studyEvents="studyEvents" let-showMore="showMore">
  @if (studyEvents.length > 3) {
    <sis-show-more
      [text]="
        showMore
          ? ('ENROLMENTS.ENROLMENT_MODAL.STUDY_GROUP.EVENTS_SHOW_REST' | translate)
          : ('ENROLMENTS.ENROLMENT_MODAL.STUDY_GROUP.EVENTS_HIDE_REST' | translate)
      "
      [direction]="showMore ? 'cw-90' : 'ccw-90'"
      [placement]="showMore ? 'bottom' : 'top'"
      (click)="setVisibleEnrolments(showMore, studyEvents)">
    </sis-show-more>
  }
</ng-template>

<ng-template #popover let-showPopover="showPopover" let-popoverText="popoverText">
  @if (showPopover) {
    <sis-popover [popoverText]="popoverText | translate">
      <button type="button" class="non-button sis-popover-trigger-content" [attr.aria-label]="'ARIA_LABEL.SHOW_DETAILS' | translate">
        <sis-icon [icon]="'info-circle-fill'" aria-hidden="true"></sis-icon>
      </button>
    </sis-popover>
  }
</ng-template>

<ng-template #personAndLocationList let-values="values" let-isPersonPipe="isPersonPipe">
  @for (value of values; track value; let last = $last) {
    @if (isPersonPipe) {
      <span class="study-sub-group-container__body__table__row__list-item">{{ value | publicPerson | async | personFullName }}</span>
    }
    @if (!isPersonPipe && value | location | async; as location) {
      <span class="study-sub-group-container__body__table__row__list-item"
        >{{ location.building.name | localizedString }} {{ location.name | localizedString }}</span
      >
    }
  }
</ng-template>
